export enum UserTypes {
  Benefit = 1,
  Merchant = 2,
}

export enum ToastTypes {
  Cart = 1,
  Success = 2,
  Info = 3,
  Error = 4,
}

export enum ProductStatusTypes {
  Archived = 0,
  Active = 1,
  Draft = 2,
  PendingApproval = 3,
  Rejected = 4,
  PendingDeactivation = 5,
}

export enum LanguageTypes {
  En = 1,
  Ro = 2,
}

export enum HttpStatuses {
  Ok = 200,
  Unauthorized = 401,
  NotFound = 404,
  PreconditionFailed = 412,
  InternalServerError = 500,
}
